export const External = () => (
  <svg height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0417 15.0417H3.95833V3.95833H9.5V2.375H3.95833C3.07958 2.375 2.375 3.0875 2.375 3.95833V15.0417C2.375 15.9125 3.07958 16.625 3.95833 16.625H15.0417C15.9125 16.625 16.625 15.9125 16.625 15.0417V9.5H15.0417V15.0417ZM11.0833 2.375V3.95833H13.9254L6.14333 11.7404L7.25958 12.8567L15.0417 5.07458V7.91667H16.625V2.375H11.0833Z"
      fill="currentColor"
    />
  </svg>
)
